import React from 'react';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <span className="logo-icon">🚀</span>
              <span className="logo-text">CreateMyApp<span className="logo-domain">.ca</span></span>
            </div>
            <p className="footer-description">
              Transforming ideas into exceptional digital experiences. 
              Professional web and mobile app development services across Canada.
            </p>
          </div>

          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><a href="#services">Web Development</a></li>
              <li><a href="#services">iOS Development</a></li>
              <li><a href="#services">Android Development</a></li>
              <li><a href="#services">Cross-Platform Apps</a></li>
              <li><a href="#services">UI/UX Design</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              <li><a href="#process">Our Process</a></li>
              <li><a href="#portfolio">Portfolio</a></li>
              <li><a href="#contact">Contact Us</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#careers">Careers</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact</h4>
            <ul>
              <li>📧 info@createmyapp.ca</li>
              <li>📱 604-773-1594</li>
              <li>📍 Surrey, BC, Canada</li>
            </ul>
            <div className="footer-social">
              <a href="#" className="social-link" aria-label="LinkedIn">💼</a>
              <a href="#" className="social-link" aria-label="Twitter">🐦</a>
              <a href="#" className="social-link" aria-label="GitHub">💻</a>
              <a href="#" className="social-link" aria-label="Instagram">📸</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} CreateMyApp. All rights reserved.</p>
          <div className="footer-links">
            <a href="/privacy-policy">Privacy Policy</a>
            <span>•</span>
            <a href="/terms-of-service">Terms of Service</a>
            <span>•</span>
            <a href="/cookie-policy">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
